import React, { useEffect, useState } from "react";
import FuelCard from "./FuelCard";
import ApiManager from "../../ApiManager/ApiManager";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import NewFuelTransaction from "../Fuel/NewFuelTransction";

const FuelDrawerTable = ({ row, from, to, drawerWidth }) => {
  const [fuels, setFuels] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFuels = async () => {
    setLoading(true);
    try {
      console.log('Fetching fuels with:', { driverId: row.driver_id, from, to });
      const queryObj = {
        driverId: row.driver_id,
        page_size: 1000,
        page: 1,
      };
      if (from) queryObj.from = from;
      if (to) queryObj.to = to;
      console.log('Query object:', queryObj);
      const query = new URLSearchParams(queryObj);
      console.log('Query string:', query.toString());
      const response = await ApiManager.getAllFuelTransactions(query);
      if (!response.ok) throw new Error("Failed to fetch fuel transactions");
      const data = await response.json();
      const driverPaidFuels = data ? data.filter(fuel => fuel.is_paid_by_driver === true && fuel.status === 'approved') : [];
      setFuels(driverPaidFuels);
      console.log('Fetched fuels:', driverPaidFuels);
    } catch (error) {
      setFuels([]);
      console.log('Error fetching fuels:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFuels();
    // eslint-disable-next-line
  }, [row.driver_id, from, to]);

  if (loading) return <LoadingSpinner message="Loading fuel data..." />;
  if (!fuels.length) return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <NewFuelTransaction onSuccess={fetchFuels} />
      </div>
      No fuel records found.
    </div>
  );

  return (
    <div style={{ padding: 8 }}>
      <div style={{ margin: 16, display: "flex", justifyContent: "flex-end" }}>
        <NewFuelTransaction onSuccess={fetchFuels} />
      </div>
      {fuels.map((item, idx) => (
        <FuelCard key={item.id || idx} fuel={item} />
      ))}
    </div>
  );
};

export default FuelDrawerTable; 